import { Component, Optional, Inject } from '@angular/core';
import {
  Studies,
  Cities,
  Ages,
  Childs,
  CivilStatus,
  Gender,
  Bank,
} from './constants';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'makaw-machine-learning-modal',
  templateUrl: './machine-learning-modal.component.html',
  styleUrls: ['./machine-learning-modal.component.scss'],
})
export class MachineLearningModalComponent {
  public studies = Studies;
  public cities = Cities;
  public ages = Ages;
  public childs = Childs;
  public civilStatus = CivilStatus;
  public gender = Gender;
  public bank = Bank;

  public cancel = false;
  public mlForm: FormGroup;
  public action: string;
  public headerMessage: string;
  public requestData: number[];

  constructor(
    public dialogRef: MatDialogRef<MachineLearningModalComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder
  ) {
    this.headerMessage = this.data.msg;
    this.action = data.action;
    this._buildMlForm();
  }

  public onSubmit() {
    if (!this.cancel) this.submitForm();
  }

  public submitForm() {
    this._buildRequestData();
    this.dialogRef.close({ event: this.action, data: this.requestData });
  }

  closeDialog() {
    this.cancel = true;
    this.dialogRef.close({ event: 'Cancel' });
  }

  private _buildMlForm() {
    this.mlForm = this.formBuilder.group({
      studies: new FormControl('', Validators.required),
      cities: new FormControl('', Validators.required),
      ages: new FormControl('', Validators.required),
      childs: new FormControl('', Validators.required),
      civilStatus: new FormControl('', Validators.required),
      gender: new FormControl('', Validators.required),
      bank: new FormControl('', Validators.required),
    });
  }

  private _buildRequestData() {
    const {
      studies,
      cities,
      ages,
      childs,
      civilStatus,
      gender,
      bank,
    } = this.mlForm.value;

    this.requestData = [
      studies,
      cities,
      ages,
      childs,
      civilStatus,
      gender,
      bank,
    ];
  }
}
